
import { Accessibility } from "./accessibility"
import { Account } from "./account"
import { User } from "./user"
import { Laverie } from "./laverie"
import { Product } from "./product"

export enum MotifRetour {
    FIN_CONTRAT = "FIN_CONTRAT",
    PANNE = "PANNE"
}

export enum EnleverPar {
    TECHNIQUE = "TECHNIQUE",
    TRANSPORTS = "TRANSPORTS",
    AUTRE = "AUTRE"
}

export interface BonRetour {
    account: Account
    laverie: Laverie
    motifRetour: MotifRetour
    enleverPar: EnleverPar
    enleverParText: string
    observations: string
    accessibility: Accessibility
    contactSecond: User
    pickupDate?: Date
    receivedDate: Date
    selectedProducts: Product[]
}

export class BonRetourGen {
    // laverie.numeroDeContrat
    lnc: string

    // laverie.name
    ln: string

    // laverie.address.ville
    lav: string

    // laverie.address.numero
    lan: string

    // laverie.address.rue
    lar: string

    // laverie.address.codepostale
    lacp: string

    // selectedProducts
    sp: Product[]

    // motifRetour.FIN_CONTRAT
    mrf: string
    hmrf: boolean

    // motifRetour.PANNE
    mrp: string
    hmrp: boolean

    // enleverPar.TECHNIQUE
    ept: string
    hept: boolean

    // enleverPar.TRANSPORTS
    eptr: string
    heptr: boolean

    // enleverPar.AUTRE
    epa: string
    hepa: boolean

    // accessibility.etage
    aet: string
    haet: boolean

    // accessibility.codePorte
    acp: string
    hacp: boolean

    // accessibility.key
    ak: string
    hak: boolean

    // accessibility.ascenseur
    aa: string
    haa: boolean

    // accessibility.escalier
    ae: string
    hae: boolean

    // accessibility.parking
    ap: string
    hap: boolean

    // laverie.gestionnaire
    cpn: string
    hcpn: boolean

    // laverie.gestionnaire fonction
    cpf: string
    hcpf: boolean

    // laverie.telephonePrincipal
    cpt: string
    hcpt: boolean

    // laverie.telephoneAutre
    cpm: string
    hcpm: boolean

    // contactSecond.name
    csn: string
    hcsn: boolean

    // contactSecond.fonction
    csf: string
    hcsf: boolean

    // contactSecond.telephone
    cst: string
    hcst: boolean

    // contactSecond.mobile
    csm: string
    hcsm: boolean

    // observations
    o: string
    ho: boolean

    // pickupDate
    pd: string
    hpd: boolean

    // receivedDate
    rd: string
    hrd: boolean
}

export function flattenBonRetour(input: BonRetour): BonRetourGen {
    const b = new BonRetourGen()
    if (input.laverie) {
        b.ln = input.laverie.name
        b.lnc = input.laverie.numeroDeContrat.toString()
        b.lan = input.laverie.address.numero
        b.lar = input.laverie.address.rue
        b.lav = input.laverie.address.ville
        b.lacp = input.laverie.address.codepostale
    }
    if (input.selectedProducts && input.selectedProducts.length > 0) {
        b.sp = input.selectedProducts
    }
    if (input.accessibility) {
        if (input.accessibility.etage) {
            b.aet = input.accessibility.etage
            b.haet = true
        } else {
            b.haet = false
        }
        if (input.laverie && input.laverie.codeAcces) {
            b.acp = input.laverie.codeAcces
            b.hacp = true
        } else {
            b.hacp = false
        }
        if (input.accessibility.key) {
            b.ak = input.accessibility.key
            b.hak = true
        } else {
            b.hak = false
        }
        if (input.accessibility.ascenseur) {
            b.aa = input.accessibility.ascenseur
            b.haa = true
        } else {
            b.haa = false
        }
        if (input.accessibility.escalier) {
            b.ae = input.accessibility.escalier
            b.hae = true
        } else {
            b.hae = false
        }
        if (input.accessibility.parking) {
            b.ap = input.accessibility.parking
            b.hap = true
        } else {
            b.hap = false
        }
    }
    // laverie.gestionnaire
    if (input.laverie && input.laverie.gestionnaire) {
        b.cpn = input.laverie.gestionnaire
        b.hcpn = true
    } else {
        b.hcpn = false
    }
    b.cpf = "Gestionnaire"
    b.hcpf = true

    if (input.laverie && input.laverie.telephoneAutre) {
        b.cpt = input.laverie.telephoneAutre
        b.hcpt = true
    } else {
        b.hcpt = false
    }
    if (input.laverie && input.laverie.telephonePrincipal) {
        b.cpm = input.laverie.telephonePrincipal
        b.hcpm = true
    } else {
        b.hcpm = false
    }

    if (input.contactSecond) {
        if (input.contactSecond.name) {
            b.csn = input.contactSecond.name
            b.hcsn = true
        } else {
            b.hcsn = false
        }
        if (input.contactSecond.fonction) {
            b.csf = input.contactSecond.fonction
            b.hcsf = true
        } else {
            b.hcsf = false
        }
        if (input.contactSecond.telephone) {
            b.cst = input.contactSecond.telephone
            b.hcst = true
        } else {
            b.hcst = false
        }
        if (input.contactSecond.mobile) {
            b.csm = input.contactSecond.mobile
            b.hcsm = true
        } else {
            b.hcsm = false
        }
    }
    if (input.pickupDate) {
        b.pd = input.pickupDate.toString()
        b.hpd = true
    } else {
        b.hpd = false
    }
    if (input.motifRetour === MotifRetour.FIN_CONTRAT) {
        b.mrf = "X"
        b.hmrf = true
    } else {
        b.hmrf = false
    }
    if (input.motifRetour === MotifRetour.PANNE) {
        b.mrp = "X"
        b.hmrp = true
    } else {
        b.hmrp = false
    }
    if (input.observations) {
        b.o = input.observations
        b.ho = true
    } else {
        b.ho = false
    }
    if (input.receivedDate) {
        b.rd = input.receivedDate.toString()
        b.hrd = true
    } else {
        b.hrd = false
    }
    if (input.enleverPar) {
        if (input.enleverPar == EnleverPar.TECHNIQUE) {
            b.ept = "X"
            b.hept = true

        } else {
            b.hept = false
        }
        if (input.enleverPar == EnleverPar.TRANSPORTS) {
            b.eptr = "X"
            b.heptr = true

        } else {
            b.heptr = false
        }
        if (input.enleverPar == EnleverPar.AUTRE) {
            if (input.enleverParText) {
                b.epa = input.enleverParText
            } else {
                b.epa = "X"
            }
            b.hepa = true
        } else {
            b.hepa = false
        }
    } else {
        b.hept = false
        b.heptr = false
        b.hepa = false
    }
    return b
}